import { Loader2 } from 'lucide-react';
import { Card } from '@/components/ui/card';

export function BlockSpinner() {
  return (
    <Card className="mx-auto mt-24 w-fit p-8">
      <Loader2 className="mx-auto h-8 w-8 animate-spin" />
    </Card>
  );
}

// Simple loading spinner for inline use
export function Loading() {
  return <Loader2 className="h-8 w-8 animate-spin" />;
}
